<template>
  <div class="back-button">
    <BaseIcon name="chevron-left" class="icon margin-right" @click.native="goBack"/>
    <ul>
      <li>
        <div
          class="center underline"
          @click="goBack"
        >GO BACK</div>
      </li>
    </ul>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseIcon
  },
   
  props: {
    backRoute: String,
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/pageBackButton.scss";
</style>